<fou-group v-if="rejectionHistory.length > 0" class="messageSectionContainer">
  <fou-container :id="$vId(this, 'rejection-history')" cols="12" background>
    <template #header>
      <h3 class="mt-h3" slot="header">Rejection History.</h3>
    </template>
    <template #content>
      <v-grid>
        <v-row>
          <v-col has="10" off="1">
            <div class="out-left out-right">
              <section class="mt-section">
                <div
                  v-for="(rejection, index) in rejectionHistory"
                  :class="[$style.bgDesign, {[$style.messageHistorySection] : (index !=0)}]"
                  v-show="index !==0 ? messageSectionVisible : true"
                >
                  <div :class="$style.bgSupport">
                    <div :class="$style.dateTimeSection">
                      <div class="mt-line" :class="$style.foundrySupportName">
                        <div>
                          <span :class="$style.senderName">Foundry Support</span>
                        </div>
                      </div>
                      <div class="mt-line" :class="$style.messageDateFoundrySupport">
                        <div>
                          <span class="mt-serif mt-serif--size5">
                            {{formatUTCtoEST(rejection.date, $lang, 'MM.DD.YYYY')}}
                          </span>
                        </div>
                      </div>
                      <div class="mt-line" :class="$style.nameAndTimeFoundrySupport">
                        <div>
                          <span class="mt-serif mt-serif--size5">
                            {{formatUTCtoEST(rejection.date, $lang, 'LT')}}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div :class="$style.mBtmLeft">
                      <div class="mt-line" :class="$style.messageContentFoundrySupport">
                        <h4 class="mt-serif mt-serif--size5" v-html="rejection.message"></h4>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
            <template v-if="rejectionHistory.length > 1">
              <div class="mt-line" :class="$style.expandCollapseButton">
                <div>
                  <a @click.prevent="setMessageSectionVisible"><span>{{expandButtonText}}</span></a>
                </div>
              </div>
            </template>
          </v-col>
        </v-row>
      </v-grid>
    </template>
  </fou-container>
</fou-group>
